const ChartItems = ({ loop }) => {
  return (
    <div className="items">
      {loop &&
        loop.map((lp, index) => {
          return (
            <div key={index} className="item">
              <img src={lp.file.src} alt={lp.file.title} />
              <h3>{lp.title}</h3>
              <div className="index">{index+1}</div>
            </div>
          );
        })}
    </div>
  );
};

export default ChartItems;
